const supportURL = "https://psma-ts.atlassian.net/servicedesk/customer/portal/1/group/1/create/1"
const stripeUrl = "https://stripe.com/en-au"

export {
    supportURL, 
    stripeUrl,
}
